import { ApiProperty } from "@nestjs/swagger";

export class IndentQuantityRequest {
    @ApiProperty()
    product:number;
    @ApiProperty()

    count:number
    @ApiProperty()

    fromDate: Date;
    @ApiProperty()

    toDate: Date;
    constructor(product:number,count:number,fromDate: Date, toDate: Date) {
        this.product = product;
        this.count = count;
        this.fromDate = fromDate;
        this.toDate = toDate;
    }
}